import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=2e4fd923&scoped=true&"
import script from "./NavMenu.vue?vue&type=script&lang=js&"
export * from "./NavMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavMenu.vue?vue&type=style&index=0&id=2e4fd923&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4fd923",
  null
  
)

export default component.exports